export const BASE = {
  HOURS_IN_DAY: 24,
  DAYS_IN_WEEK: 7,
  DAYS_IN_MONTH: 30,
  MINUTES_IN_HOUR: 60,
  SECONDS_IN_MINUTE: 60,
  MILLISECONDS_IN_SECOND: 1000,
};

export const TIME = {
  MINUTES: {
    PER_HOUR: BASE.MINUTES_IN_HOUR,
    PER_DAY: BASE.HOURS_IN_DAY * BASE.MINUTES_IN_HOUR,
  },
  SECONDS: {
    PER_MINUTE: BASE.SECONDS_IN_MINUTE,
    PER_HOUR: BASE.SECONDS_IN_MINUTE * BASE.MINUTES_IN_HOUR,
    PER_DAY: BASE.HOURS_IN_DAY * BASE.MINUTES_IN_HOUR * BASE.SECONDS_IN_MINUTE,
    PER_WEEK: BASE.DAYS_IN_WEEK * BASE.HOURS_IN_DAY * BASE.MINUTES_IN_HOUR * BASE.SECONDS_IN_MINUTE,
    PER_MONTH: BASE.DAYS_IN_MONTH * BASE.HOURS_IN_DAY * BASE.MINUTES_IN_HOUR * BASE.SECONDS_IN_MINUTE,
  },
  MILLISECONDS: {
    PER_SECOND: BASE.MILLISECONDS_IN_SECOND,
    PER_MINUTE: BASE.MILLISECONDS_IN_SECOND * BASE.SECONDS_IN_MINUTE,
    PER_HOUR: BASE.MILLISECONDS_IN_SECOND * BASE.SECONDS_IN_MINUTE * BASE.MINUTES_IN_HOUR,
    PER_DAY: BASE.MILLISECONDS_IN_SECOND * BASE.SECONDS_IN_MINUTE * BASE.MINUTES_IN_HOUR * BASE.HOURS_IN_DAY,
    PER_WEEK:
      BASE.MILLISECONDS_IN_SECOND *
      BASE.SECONDS_IN_MINUTE *
      BASE.MINUTES_IN_HOUR *
      BASE.HOURS_IN_DAY *
      BASE.DAYS_IN_WEEK,
    PER_MONTH:
      BASE.MILLISECONDS_IN_SECOND *
      BASE.SECONDS_IN_MINUTE *
      BASE.MINUTES_IN_HOUR *
      BASE.HOURS_IN_DAY *
      BASE.DAYS_IN_MONTH,
  },
};

/** Days of the week in order (Monday to Sunday) */
export const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] as const;

/** Type for valid day of week values */
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];
